import { Milestone, MilestoneStatus } from "../types";

// Helper to generate a unique ID
const generateId = () => Math.random().toString(36).substr(2, 9);

export const generateMilestones = async (projectDescription: string): Promise<Milestone[]> => {
  try {
    // Call the Vercel Serverless Function
    const response = await fetch('/api/milestones', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ description: projectDescription }),
    });

    if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
    }

    const { text } = await response.json();
    const data = JSON.parse(text || "[]");
    
    return data.map((item: any) => ({
      id: generateId(),
      title: item.title,
      status: MilestoneStatus.NOT_STARTED,
      duration: item.duration || 3, // Default to 3 days if missing
      comments: []
    }));

  } catch (error) {
    console.error("Failed to generate milestones:", error);
    return [];
  }
};